export const ADMIN = 'ADMIN';
export const CREATE_AND_OWN = 'CREATE_AND_OWN';
export const EDIT = 'EDIT';
export const NONE = 'NONE';
export const VIEW = 'VIEW';